<div class="flex-column gap">
    <div class="flex gap pt-2 pt-2">
        <div class="flex-column gap flex-3 pt-2">
            @if (serviceGroupHasValidity(dialogConfig.data.groupType)) {
                <div class="flex gap">
                    <app-date-input
                        [form]="form"
                        class="flex-1"
                        id="validFrom"
                        timeType="startOfDay"
                    ></app-date-input>
                    <app-date-input
                        [form]="form"
                        class="flex-1"
                        id="validTo"
                        timeType="endOfDay"
                    ></app-date-input>
                </div>
            }

            @if (dialogConfig.data.groupType === ServiceGroupEnum.SOCIAL_TARGET) {
                <app-select-input
                    [form]="form"
                    id="mpsvTargetGroupId"
                    [prefix]="prefix"
                    [infiniteScroll]="store.mpsvTargetGroupScroll"
                    [valueKey]="'id'"
                    [labelKey]="'name'"
                    [filterBy]="'name'"
                ></app-select-input>
            }
            <app-select-input
                [form]="form"
                id="groupType"
                [prefix]="prefix"
                [staticOptions]="groupTypeOptions"
            ></app-select-input>
            <app-text-input [form]="form" id="name" [prefix]="prefix"></app-text-input>
            <app-text-input [form]="form" id="description" [prefix]="prefix"></app-text-input>
            <app-check-input [form]="form" id="active" [prefix]="prefix"></app-check-input>
        </div>

        <app-color-input class="flex-1 pt-2" [form]="form"></app-color-input>
    </div>

    @if (serviceGroup?.type === ServiceGroupEnum.SOCIAL_TARGET || serviceGroup?.type === ServiceGroupEnum.GENERAL) {
        <app-card-table
            [tableTitle]="prefix + 'upsertDialog.clients.title'"
            [gridData]="store.data.getFolderGroups()"
            [columns]="columns"
            [refreshCallback]="store.api.getFolderGroups"
            [additionalFilter]="additionalFilters()"
            [translatePrefix]="prefix"
            [refreshCallbackFragment]="folderGroupFrag"
            [hideCheckboxes]="true"
            (deleteCallbackWithEvent)="deleteFolderGroup($event)"
            (createCallback)="addFoldersGroup()"
            (detailCallback)="editItemValidity($event)"
        ></app-card-table>
    }

    @if (serviceGroup?.type === ServiceGroupEnum.OFFERS) {
        <app-card-table
            [tableTitle]="prefix + 'upsertDialog.offers.title'"
            [gridData]="store.data.getSocialServiceOfferGroups()"
            [columns]="offerColumns"
            [refreshCallback]="store.api.getSocialServiceOfferGroups"
            [additionalFilter]="additionalFilters()"
            [translatePrefix]="prefix"
            [refreshCallbackFragment]="offerGroupFrag"
            [hideCheckboxes]="true"
            (deleteCallbackWithEvent)="deleteOfferGroup($event)"
            (createCallback)="addOffersGroup()"
            (detailCallback)="editItemValidity($event, true)"
        ></app-card-table>
    }
</div>
